import React from 'react';
import {string, node, number} from 'prop-types';
import Icon from '../icon';
import './text-section.css';

const TextSection = ({title, text, index}) => (
  <div className="panel panel-custom panel-classic">
    <div className="panel-custom-heading" id={`${index}Heading`} role="tab">
      <h5 className="panel-custom-title">
        <a
          className="collapsed"
          role="button"
          data-toggle="collapse"
          data-parent={`#${index}`}
          href={`#${index}Collapse`}
          aria-controls={`${index}Collapse`}
          aria-expanded="false"
        >
          <Icon name="chevron" />
          {title}
        </a>
      </h5>
    </div>
    <div
      className="panel-custom-collapse collapse"
      id={`${index}Collapse`}
      role="tabpanel"
      aria-labelledby={`${index}Heading`}
    >
      <div className="panel-custom-body">{text}</div>
    </div>
  </div>
);

TextSection.propTypes = {
  title: string.isRequired,
  text: node.isRequired,
  index: number.isRequired
};

export default TextSection;
